import type { MatchDetails } from "./types";

// ==================================================
// MATCH DETAILS 2026 — MEN'S DOMESTIC
// BUNNINGS NPC
// ==================================================

export const matchDetailsNPC: MatchDetails[] = [
  {
  matchKey: "northland-vs-otago-npc-2026",
  timeline: [
    { minute: "0'", label: "Kick-off — Semenoff Stadium, Whangārei" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Northland 38–19 Otago" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=XxpxaIqv34Q",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Northland" },
    { category: "Coach", player: "TBD", value: "Otago" },
    { category: "Venue", player: "Semenoff Stadium", value: "Whangārei" },
    { category: "Note", player: "Northland", value: "First-ever NPC Final appearance" },
  ],
},
  {
  matchKey: "canterbury-vs-taranaki-npc-2026",
  timeline: [
    { minute: "0'", label: "Kick-off — One NZ Stadium, Christchurch" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Canterbury 38–28 Taranaki" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=txVI-DvV9b4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Canterbury" },
    { category: "Coach", player: "TBD", value: "Taranaki" },
    { category: "Venue", player: "One NZ Stadium", value: "Christchurch" },
    { category: "Note", player: "Canterbury", value: "Hosts the Grand Final" },
  ],
},

{
  matchKey: "canterbury-vs-northland-npc-final-2026",
  timeline: [
    { minute: "0'", label: "Kick-off — One NZ Stadium, Christchurch" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=8-JS__ByV6A",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Canterbury" },
    { category: "Coach", player: "TBD", value: "Northland" },
    { category: "Captain", player: "TBD", value: "Canterbury" },
    { category: "Captain", player: "TBD", value: "Northland" },
    { category: "Venue", player: "One NZ Stadium", value: "Christchurch" },
    { category: "Note", player: "Northland", value: "First-ever NPC Grand Final appearance" },
    { category: "Note", player: "Canterbury", value: "Defending champions / Home final" },
  ],
},
];